<template>
    <transition name="fade">
        <div class="preview-question-modal" @click="onClickOverlay">
            <div class="preview-close">
                <i @click="closeModal" class="preview-icon fas fa-times-circle text-white cursor-pointer"></i>
            </div>
            <div class="preview-iframe relative overflow-hidden">
                <div
                    v-if="this.isTeacher"
                    v-html="$t('preview_question_basic_plan', { role: $t('school_role_teacher_basic') })"
                    class="text-preview absolute"
                ></div>
                <iframe :src="url" frameborder="0" class="absolute w-full h-full"></iframe>
            </div>
        </div>
    </transition>
</template>

<script>
import helperMixins from '@/mixins/helper.js'
export default {
    props: {
        url: {
            type: String,
            default: ''
        }
    },

    mixins: [helperMixins],

    methods: {
        closeModal() {
            this.$emit('close')
        },

        onClickOverlay(e) {
            if (e.target.classList.toString().indexOf('preview-question-modal') > -1) {
                this.closeModal()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-question-modal {
    z-index: 9990;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);

    .preview-close {
        cursor: pointer;
        z-index: 9999;
        position: fixed;
        top: calc(5.5% + 0.5vw);
        right: calc(5.3% + 0.5vh);
        width: 32px;
        height: 32px;
    }

    .preview-icon {
        filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.3));
        font-size: 1.75rem;
        color: #ffffff;
    }

    .preview-iframe {
        background-image: var(--background-image);
        z-index: 9998;
        width: 90%;
        height: 90%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: none;
        border-radius: 10px;
        box-shadow: 0 0 50px rgba(0, 0, 0, 0.5);

        .text-preview {
            z-index: 9999;
            width: fit-content;
            background-color: rgba(0, 0, 0, 0.3);
            color: #ffffff;
            padding: 0.5rem 1rem;
            border-top-left-radius: 0.5rem;
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
            font-size: 0.75rem;

            @media screen and (max-width: 875px) {
                width: 80%;
            }
        }
    }
}
</style>
